import { designMode } from '@/env';
import { api } from '@/api';
import { IProductResponce, IProductReport, IFinanceResponce, IFinanceReport, IFinancialInfoMaterialReport, IFinancialInfoMaterialsResponse, IFundraisingResponce, IFundraisingReport, ReportValidation } from './index';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { dispatchCheckApiError } from '../main/actions';
import { State } from '../state';
import { commitSetReportData, commitSetReports, commitSetFinance, commitSetFinancialInfoMaterials, commitSetFundraisings, commitSetProduct, commitSetReportValidation } from './mutations';
import { MainState } from '../main/state';
import { ReportState } from './state';
import { toBoolean } from '@/utils';
import { commitAddNotification } from '../main/mutations';
import { DashboadData } from '@/utils/data/dashboard';
import { IToDo } from '@/interfaces/report';
import { IWPColumn } from '../main';
import { AxiosError } from 'axios';

type MainContext = ActionContext<MainState, State>;
type ReportContext = ActionContext<ReportState, State>;
const FileDownload = require('js-file-download');

export const actions = {
    async actionCheckReportValidation(context: ReportContext) {
        try {
            let data: any;
            if (toBoolean(designMode)) {
                let dummy: ReportValidation = {
                    // 申請ボタンを活性化する場合は*_validationの項目を全てtrueにすること
                    product_validation: true,
                    finance_validation: true,
                    financial_info_validation: false,
                    fundrasing_validation: false,
                    product_messages: [
                        'プロダクト/サービス名が不正確です。',
                        'プロダクト/サービスURLが不正確です。',
                    ],
                    finance_messages: [],
                    financial_info_messages: [],
                    fundrasing_messages: [],
                    result_incompleted: false
                };
                data = dummy;
            } else {
                const response = await api.checkReportValidation(context.rootState.main.token);
                data = response.data;
            }
            if (data) {
                commitSetReportValidation(context, data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetLatestProduct(context: ReportContext) {
        try {
            let data: any;
            if (toBoolean(designMode)) {
                let dummy: IProductResponce = {
                    id: 0,
                    company_id: 0,
                    name: 'CFOAi Products',
                    url: 'cfoai-product.com',
                    description: 'プロダクトやサービス概要が入ります。プロダクトやサービス概要が入ります。プロダクトやサービス概要が入ります。',
                    materials: [{
                        id: 1,
                        file_size: 100,
                        file_name: '株式会社会社CFO.Ai事業説明資料.pptx',
                        mime_type: 'application/vnd.ms-powerpoint',
                        created_at: '',
                        created_by: { id: 0 },
                        updated_at: '',
                        updated_by: { id: 0 },
                    }],
                    created_at: '',
                    created_by: {
                        id: 0
                    },
                    updated_at: '',
                    updated_by: {
                        id: 0
                    }
                };
                data = dummy;
            } else {
                const response = await api.getProductReport(context.rootState.main.token);
                data = response.data;
            }
            if (data) {
                commitSetProduct(context, data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionReportProduct(context: ReportContext, payload: IProductReport) {
        if (!toBoolean(designMode)) {
            try {
                if (payload.deleteFileIds.length > 0) {
                    for (let file_id of payload.deleteFileIds) {
                        await Promise.all([
                            api.deleteProductMaterials(context.rootState.main.token, file_id),
                            await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                        ]);
                    }
                }
                if (payload.uploadFiles.length > 0) {
                    await Promise.all([
                        api.updateProductMaterials(context.rootState.main.token, payload.uploadFiles),
                        await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                    ]);
                }
                const response = (await Promise.all([
                    api.putProductReport(context.rootState.main.token, payload.product_id, payload.productRequest),
                    await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                ]))[0];
                if (response.data) {
                    commitSetProduct(context, response.data);
                }
                commitAddNotification(context, { content: 'レポート情報の編集が正常に保存されました', condition: 'saved' });
            } catch (error) {
                await dispatchCheckApiError(context, error);
            }
        }
    },
    async actionGetLatestFinance(context: ReportContext) {
        try {
            let data: any;
            if (toBoolean(designMode)) {
                let dummy: IFinanceResponce = {
                    id: 0,
                    company_id: 0,
                    expect_finance_date: new Date(),
                    expect_finance_amount: 0,
                    expect_finance_method: ["debt", "equity"],
                    expect_valuation_pre: 0,
                    achievement: '金融機関・投資家にアピールしたい実績があれば、教えてください',
                    use_of_funds: ["人件費", "外注費・業務委託費"],
                    materials: [{
                        id: 1,
                        file_size: 100,
                        file_name: '株式会社会社CFO.Ai事業説明資料.pptx',
                        mime_type: 'application/vnd.ms-powerpoint',
                        created_at: '',
                        created_by: { id: 0 },
                        updated_at: '',
                        updated_by: { id: 0 },
                    }],
                    created_at: '',
                    created_by: {
                        id: 0
                    },
                    updated_at: '',
                    updated_by: {
                        id: 0
                    },
                };
                data = dummy;
            } else {
                const response = await api.getFinanceReport(context.rootState.main.token);
                data = response.data;
            }
            if (data) {
                commitSetFinance(context, data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionReportFinance(context: ReportContext, payload: IFinanceReport) {
        if (!toBoolean(designMode)) {
            try {
                if (payload.deleteFileIds.length > 0) {
                    for (let file_id of payload.deleteFileIds) {
                        await Promise.all([
                            api.deleteFinanceMaterials(context.rootState.main.token, file_id),
                            await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                        ]);
                    }
                }
                if (payload.uploadFiles.length > 0) {
                    await Promise.all([
                        api.updateFinanceMaterials(context.rootState.main.token, payload.uploadFiles),
                        await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                    ]);
                }
                const response = (await Promise.all([
                    api.putFinanceReport(context.rootState.main.token, payload.finance_id, payload.financeRequest),
                    await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                ]))[0];
                if (response.data) {
                    commitSetFinance(context, response.data);
                }
                commitAddNotification(context, { content: 'レポート情報の編集が正常に保存されました', condition: 'saved' });
            } catch (error) {
                await dispatchCheckApiError(context, error);
            }
        }
    },
    async actionGetFinancialinfo(context: ReportContext) {
        try {
            let data: any;
            if (toBoolean(designMode)) {
                let dummy: IFinancialInfoMaterialsResponse = [{
                    id: 1,
                    company_id: 1,
                    kind: 0,
                    file_size: 100,
                    file_name: '株式会社会社CFO.Ai事業説明資料.pptx',
                    mime_type: 'application/vnd.ms-powerpoint',
                    created_at: '',
                    created_by: { id: 0 },
                    updated_at: '',
                    updated_by: { id: 0 },
                }];
                data = dummy;
            } else {
                const response = await api.getFinancialInfoMaterialsReport(context.rootState.main.token);
                data = response.data;
            }
            if (data) {
                commitSetFinancialInfoMaterials(context, data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionReportFinancialInfoMaterial(context: ReportContext, payload: IFinancialInfoMaterialReport) {
        if (!toBoolean(designMode)) {
            try {
                if (payload.fs_delete_file_ids.length > 0) {
                    for (let file_id of payload.fs_delete_file_ids) {
                        await Promise.all([
                            api.deleteFinancialInfoMaterials(context.rootState.main.token, 0, file_id),
                            await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                        ]);
                    }
                }
                if (payload.sa_delete_file_ids.length > 0) {
                    for (let file_id of payload.sa_delete_file_ids) {
                        await Promise.all([
                            api.deleteFinancialInfoMaterials(context.rootState.main.token, 1, file_id),
                            await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                        ]);
                    }
                }
                if (payload.fs_upload_files.length > 0) {
                    await Promise.all([
                        api.updateFinancialInfoMaterials(context.rootState.main.token, 0, payload.fs_upload_files),
                        await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                    ]);
                }
                if (payload.sa_upload_files.length > 0) {
                    await Promise.all([
                        api.updateFinancialInfoMaterials(context.rootState.main.token, 1, payload.sa_upload_files),
                        await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                    ]);
                }
                const response = await api.getFinancialInfoMaterialsReport(context.rootState.main.token);
                if (response.data) {
                    commitSetFinancialInfoMaterials(context, response.data);
                }
                commitAddNotification(context, { content: 'レポート情報の編集が正常に保存されました', condition: 'saved' });
            } catch (error) {
                await dispatchCheckApiError(context, error);
            }
        }
    },
    async actionGetFundraising(context: ReportContext) {
        try {
            let data: any;
            if (toBoolean(designMode)) {
                let dummy: IFundraisingResponce = {
                    fundraised: true,
                    fundraising_json: '[{"id": 1, "method": "debt", "from_name": "test", "amount": 100, "payment_date": "2022-07-28", "repayment_date": "2022-07-28", "rescheduled": true, "repayment_type": 1, "interest_payment_type": 0, "valuation_post": null }]'
                };
                data = dummy;
            } else {
                const response = await api.getFundraisingReport(context.rootState.main.token);
                data = response.data;
            }
            if (data) {
                let obj = JSON.parse(data.fundraising_json);
                let fundraisings = obj
                for (let i = 0; i < obj.length; i++) {
                    if (obj[i].payment_date) {
                        fundraisings[i].payment_date = new Date(obj[i].payment_date)
                    }
                    if (obj[i].repayment_date) {
                        fundraisings[i].repayment_date = new Date(obj[i].repayment_date)
                    }
                }
                let commitData: IFundraisingReport = {
                    fundraised: data.fundraised,
                    fundraisings: obj,
                    fundraisingDeleteIds: [],
                };
                commitSetFundraisings(context, commitData);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionReportFundraising(context: ReportContext, payload: IFundraisingReport) {
        if (!toBoolean(designMode)) {
            try {
                if (payload.fundraisingDeleteIds.length > 0) {
                    for (let id of payload.fundraisingDeleteIds) {
                        await Promise.all([
                            api.deleteFundraisingReport(context.rootState.main.token, id),
                            await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                        ]);
                    }
                }
                const response = (await Promise.all([
                    api.putFundraisingReport(context.rootState.main.token, payload),
                    await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                ]))[0];
                if (response.data) {
                    let obj = JSON.parse(response.data.fundraising_json);
                    let fundraisings = obj
                    for (let i = 0; i < obj.length; i++) {
                        if (obj[i].payment_date) {
                            fundraisings[i].payment_date = new Date(obj[i].payment_date)
                        }
                        if (obj[i].repayment_date) {
                            fundraisings[i].repayment_date = new Date(obj[i].repayment_date)
                        }
                    }
                    let commitData: IFundraisingReport = {
                        fundraised: response.data.fundraised,
                        fundraisings: fundraisings,
                        fundraisingDeleteIds: [],
                    };
                    commitSetFundraisings(context, commitData);
                }
                commitAddNotification(context, { content: 'レポート情報の編集が正常に保存されました', condition: 'saved' });
            } catch (error) {
                await dispatchCheckApiError(context, error);
            }
        }
    },
    actionGetFile(context: ReportContext, payload: { file: File; file_name: string }) {
        FileDownload(payload.file, payload.file_name);
    },
    async actionGetProductMaterial(context: ReportContext, payload: { id: number; file_name: string }) {
        try {
            if (!toBoolean(designMode)) {
                const response = await api.getProductMaterial(context.rootState.main.token, payload.id);
                if (response.data) {
                    FileDownload(response.data, payload.file_name);
                }
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetFinanceMaterial(context: ReportContext, payload: { id: number; file_name: string }) {
        try {
            if (!toBoolean(designMode)) {
                const response = await api.getFinanceMaterial(context.rootState.main.token, payload.id);
                if (response.data) {
                    FileDownload(response.data, payload.file_name);
                }
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetFinancialInfoMaterial(context: ReportContext, payload: { id: number; file_name: string }) {
        try {
            if (!toBoolean(designMode)) {
                const response = await api.getFinancialInfoMaterial(context.rootState.main.token, payload.id);
                if (response.data) {
                    FileDownload(response.data, payload.file_name);
                }
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionApplyReport(context: ReportContext) {
        try {
            if (!toBoolean(designMode)) {
                await Promise.all([
                    api.applyReport(context.rootState.main.token),
                    await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                ])
                commitAddNotification(context, { content: 'レポート申請を受け付けました。<br>レポートの作成が完了したらメールでお知らせします。<br>少々お待ち下さい。', condition: 'saved', timeout: 10000 })
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
            await dispatchCheckApplyReportError(context, error);
        }
    },
    async actionCheckApplyReportError(context: MainContext, payload: AxiosError) {
        if (payload.response!.status === 403) {
            commitAddNotification(context, { content: payload.response!.data.detail, condition: 'error' });
        }
    },
    async getReports(context: ReportContext) {
        try {
            let data: any;
            if (toBoolean(designMode)) {
                let dummy = new DashboadData();
                data = dummy.getReports(); // レポートデータあり
                // data = []; // レポートデータなし
            } else {
                const response = await api.getReports(context.rootState.main.token);
                data = response.data;
            }
            if (data) {
                commitSetReports(context, data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async dispatchGetTodos(context: ReportContext): Promise<IToDo[]> {
        try {
            let data: IToDo[];
            if (toBoolean(designMode)) {
                data = [
                    { todo: "Debt（金融機関）の資料をアップしてください", updated_at: new Date('2022-9-23') },
                    { todo: "申請してください", updated_at: new Date('2022-5-23') }
                ];
            } else {
                const response = await api.getTodos(context.rootState.main.token);
                data = response.data;
            }
            return data;
        } catch (error) {
            return [];
        }
    },
    async dispatchGetWPColumns(context: ReportContext, payload: string | null): Promise<IWPColumn[]> {
        let columns: IWPColumn[] = [];
        try {
            let slug_id = null;
            if (payload) {
                const response_slug = await api.getWPTargetSlug(payload);
                slug_id = (response_slug.data.length > 0) ? response_slug.data[0]['id'] : null;
            }
            const response = await api.getWPcolumns(slug_id);
            let data: any = response.data;
            if (typeof response.data === 'string') {
                data = JSON.parse(response.data);
            }
            for (let column of data) {
                columns.push({
                    title: column.title.rendered,
                    linkUrl: column.link,
                    thumbnailUrl: (column._embedded['wp:featuredmedia'])
                        ? column._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url
                        : '',
                    date: new Date(column.date).toLocaleString().slice(0, -3),
                    author: {
                        name: column._embedded.author[0].name,
                        thumbnailUrl: (column._embedded.author[0].avatar_urls['24'])
                            ? column._embedded.author[0].avatar_urls['24']
                            : ''
                    }
                });
            }
            return columns;
        } catch (error) {
            return columns;
        }
    },
    async getReportResult(context: ReportContext, id: number) {
        try {
            let data: any;
            if (toBoolean(designMode)) {
                let dummy = new DashboadData();
                data = dummy.getReportData();
            } else {
                const response = await api.getReportResult(context.rootState.main.token, id);
                data = response.data.result;
            }
            if (data) {
                commitSetReportData(context, data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
};

const { dispatch } = getStoreAccessors<ReportState | any, State>('');


export const dispatchCheckReportValidation = dispatch(actions.actionCheckReportValidation);
export const dispatchGetLatestProduct = dispatch(actions.actionGetLatestProduct);
export const dispatchReportProduct = dispatch(actions.actionReportProduct);
export const dispatchGetLatestFinance = dispatch(actions.actionGetLatestFinance);
export const dispatchReportFinance = dispatch(actions.actionReportFinance);
export const dispatchGetFinancialinfo = dispatch(actions.actionGetFinancialinfo);
export const dispatchReportFinancialInfoMaterial = dispatch(actions.actionReportFinancialInfoMaterial);
export const dispatchGetFundraising = dispatch(actions.actionGetFundraising);
export const dispatchReportFundraising = dispatch(actions.actionReportFundraising);

export const dispatchGetFile = dispatch(actions.actionGetFile);
export const dispatchGetProductMaterial = dispatch(actions.actionGetProductMaterial);
export const dispatchGetFinanceMaterial = dispatch(actions.actionGetFinanceMaterial);
export const dispatchGetFinancialInfoMaterial = dispatch(actions.actionGetFinancialInfoMaterial);
export const dispatctApplyReport = dispatch(actions.actionApplyReport);
export const dispatchCheckApplyReportError = dispatch(actions.actionCheckApplyReportError);
export const dispatchGetReports = dispatch(actions.getReports);
export const dispatchGetTodos = dispatch(actions.dispatchGetTodos);
export const dispatchGetWPColumns = dispatch(actions.dispatchGetWPColumns);
export const dispatchGetReportResult = dispatch(actions.getReportResult);